import { useStores } from 'stores/utils/hooks/useStores'
import { isTenantSmava } from 'utils/url'
import { VoucherBannerVariant } from '../VoucherBanner.types'

const getSmavaVoucherAmount = (amount: number): number | null => {
  if (amount >= 50000) return 150
  if (amount > 30000) return 100
  if (amount > 20000 && amount < 30000) return 100
  return null
}

const getFFGVoucherAmount = (amount: number): number | null => {
  if (amount >= 50000) return 150
  if (amount >= 20000) return 100
  return null
}

export const getVoucherAmount = (
  loanAmount: number,
  variant: VoucherBannerVariant
): number | null => {
  return variant === 'smava'
    ? getSmavaVoucherAmount(loanAmount)
    : getFFGVoucherAmount(loanAmount)
}

const useVoucherAmount = (): number | null => {
  const { traversal } = useStores()
  const variant: VoucherBannerVariant = isTenantSmava() ? 'smava' : 'ffg'
  return getVoucherAmount(traversal.data.common.amount, variant)
}

export default useVoucherAmount
